$ = jQuery;
const noFileText = fileUploadTranslations.chooseFile;
const fileChosenText = fileUploadTranslations.fileChosen;

function menuOpen() {
  const btnOpen = $("#openMenu");
  const btnClose = $("#closeMenu");
  const menu = $("#menu");

  btnOpen.click(function () {
    $(this).hide();
    btnClose.show();
    menu.addClass("opened");
  });

  btnClose.click(function () {
    $(this).hide();
    btnOpen.show();
    menu.removeClass("opened");
  });
}

function updateFileLabel() {
  const inputFile = $("#file");
  if (inputFile.length) {
    const fileName = inputFile.val().split("\\").pop();
    if (fileName) {
      const truncatedFileName = truncateFileName(fileName, 10, 4);
      $(".wpcf7-file").attr("data-file-placeholder", fileChosenText);
      $(".file-name").html(truncatedFileName);
    } else {
      $(".wpcf7-file").attr("data-file-placeholder", noFileText);
      $(".file-name").html("");
    }
  }
}

function truncateFileName(fileName, maxLength, keepLast) {
  if (fileName.length > maxLength + keepLast) {
    const truncated =
      fileName.substr(0, maxLength) +
      "..." +
      " " +
      fileName.substr(fileName.length - keepLast, keepLast);
    return truncated;
  }
  return fileName;
}

$(document).ready(function () {
  $('.hero-slider').slick({
    autoplay: false,
    dots: true,
    arrows: false,
    dotsClass: 'slick-dots',
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          arrows: false,
        }
      },
    ]
  });


  $('.explosive-slider').slick({
    autoplay: false,
    dots: true,
    arrows: true,
    dotsClass: 'slick-dots',
    adaptiveHeight: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          arrows: false,
        }
      },
    ]
  });

  $('.partners-wrapper').slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: true,
    prevArrow:
    '<button type="button" class="slick-arrow slick-prev">Previous</button>',
  nextArrow:
    '<button type="button" class="slick-arrow slick-next">Next</button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });


  $(".accordion-title-toggle").click(function () {
    $(this).siblings(".accordion-description").stop().slideToggle();
    $(this).toggleClass("active");
  });

  $(".menu-item-has-children").click(function () {
    $(this).toggleClass("opened");
  });

  updateFileLabel();

  $("#file").change(function () {
    updateFileLabel();
  });

  function truncateText(selector, maxLength) {
    $(selector).each(function() {
        let element = $(this);
        let truncated = element.text();

        if (truncated.length > maxLength) {
            truncated = truncated.substr(0, maxLength) + '...';
            element.text(truncated);
        }
    });
}
truncateText('.archives-item-title', 40);

  menuOpen();
});

jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};
